import Vue from 'vue';

Vue.filter('timestampToDateTime', value => {
  
  let d = new Date(value);
  let str = '';
  
  str = ('0' + d.getDate()).slice(-2);
  str+='.';
  str+= ('0' + (d.getMonth() + 1)).slice(-2);
  str+= '.';
  str+= d.getFullYear();
  str+= ' | ';
  str+= ('0' + d.getHours()).slice(-2);
  str+= ':';
  str+= ('0' + d.getMinutes()).slice(-2);

  return str;

});

Vue.filter('timestampToDateTimeSec', value => {
  
  let d = new Date(value);
  let str = '';
  
  str = ('0' + d.getDate()).slice(-2);
  str+='.';
  str+= ('0' + (d.getMonth() + 1)).slice(-2);
  str+= '.';
  str+= d.getFullYear();
  str+= ' | ';
  str+= ('0' + d.getHours()).slice(-2);
  str+= ':';
  str+= ('0' + d.getMinutes()).slice(-2);
  str+= ':';
  str+= ('0' + d.getSeconds()).slice(-2);

  return str;

});

Vue.filter('timestampToTime', value => {
  
  let d = new Date(value);
  let str = '';
  
  str+= ('0' + d.getHours()).slice(-2);
  str+= ':';
  str+= ('0' + d.getMinutes()).slice(-2);

  return str;

});